
import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-[#1A3A52] font-['Playfair_Display']">
              Conte Advisory
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('sobre')}
              className="text-[#1A3A52] hover:text-[#00A896] font-medium transition-colors cursor-pointer"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="text-[#1A3A52] hover:text-[#00A896] font-medium transition-colors cursor-pointer"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('diferenciais')}
              className="text-[#1A3A52] hover:text-[#00A896] font-medium transition-colors cursor-pointer"
            >
              Advantages
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-[#1A3A52] hover:text-[#00A896] font-medium transition-colors cursor-pointer"
            >
              Contact
            </button>
            <Button
              variant="primary"
              size="sm"
              onClick={() => window.open('https://wa.me/5541996543210', '_blank')}
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-[#1A3A52] hover:text-[#00A896] cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('sobre')}
                className="text-[#1A3A52] hover:text-[#00A896] font-medium transition-colors text-left cursor-pointer"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('servicos')}
                className="text-[#1A3A52] hover:text-[#00A896] font-medium transition-colors text-left cursor-pointer"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('diferenciais')}
                className="text-[#1A3A52] hover:text-[#00A896] font-medium transition-colors text-left cursor-pointer"
              >
                Advantages
              </button>
              <button
                onClick={() => scrollToSection('contato')}
                className="text-[#1A3A52] hover:text-[#00A896] font-medium transition-colors text-left cursor-pointer"
              >
                Contact
              </button>
              <Button
                variant="primary"
                size="sm"
                onClick={() => window.open('https://wa.me/5541996543210', '_blank')}
                className="w-fit"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
